import { Link } from "react-router-dom";
import { RippleButton, WindReveal } from "@/components/Cinematic";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="relative bg-[#3F3F2C] text-[#F7F1E1] overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24 lg:py-32">
        <p className="signature text-2xl text-[#B4833D] mb-6">{"Let's begin —"}</p>
        <h2 className="font-serif text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl">
          <WindReveal text="Let's Build Something Worth Remembering" />
        </h2>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <RippleButton testId="footer-cta-button" onClick={() => navigate("/contact")}
            className="rounded-full bg-[#66371B] px-8 py-4 text-base text-[#F7F1E1] hover:bg-[#3F3F2C] transition-colors">
            Let's create
          </RippleButton>
          <span className="text-sm text-[#81754B]">48-hr response · NDA-friendly · New Delhi</span>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-12">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <img src="/seedesign-mark.png" alt="" aria-hidden="true" className="h-10 w-10 rounded-full" />
              <p className="font-serif text-lg">seedesign</p>
            </div>
            <p className="text-sm text-[#81754B] leading-relaxed">A brand & creative studio building premium D2C, fashion and lifestyle brands. Founded by Pravidhi Jain.</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#81754B] mb-4">Explore</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/work" className="hover:text-[#66371B]">Work</Link></li>
              <li><Link to="/services" className="hover:text-[#66371B]">Services</Link></li>
              <li><Link to="/impact" className="hover:text-[#66371B]">Impact</Link></li>
              <li><Link to="/process" className="hover:text-[#66371B]">Process</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#81754B] mb-4">Studio</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-[#66371B]">About</Link></li>
              <li><Link to="/contact" className="hover:text-[#66371B]">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#81754B] mb-4">Connect</p>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:hello@seedesign.in" className="hover:text-[#66371B]">hello@seedesign.in</a></li>
              <li><a href="https://www.behance.net/pravidhijain" target="_blank" rel="noreferrer" className="hover:text-[#66371B]">Behance</a></li>
            </ul>
          </div>
        </div>
        <p className="mt-12 text-xs text-[#81754B]">© {new Date().getFullYear()} seedesign · seedesign.in — Crafted with intention.</p>
      </div>
    </footer>
  );
}
